import React from 'react';
import DirectusSDK from '@directus/sdk-js';
import HeadlessConfig from '../config/headless';
import NachrichtEmail from '../mails/nachricht';
import './contact_form.css';

const client = new DirectusSDK();
client.login({
  url: HeadlessConfig.url,
  project: HeadlessConfig.project,
  email: HeadlessConfig.email,
  password: HeadlessConfig.password
});
export default class ContactForm extends React.Component {

  constructor(props) {
    super(props);

    this._onSubmit = this._onSubmit.bind(this);

    this.state = {
      name: {
        value: '',
        error: false,
        filled: false
      },
      email: {
        value: '',
        error: false, 
        filled: false
      },
      number: {
        value: 1,
        error: false,
        filled: true
      },
      phone: {
        value: "",
        error: false,
        filled: false
      },
      about: {
        value: "",
        error: false,
        filled: false
      },
      agb: {
        value: false,
        error: false,
        filled: false
      },
      sended: false,
      loading: false
    }
  }

  _onChangeValue(type, newValue) {
    let filled = false;   
    let error = false;

    if(newValue.trim() !== "") {
        filled = true; 
        error = false;
    } else {
        error = true;
    }

    let newObj = {};
    newObj[type] = {
        value: newValue,
        error: error,
        filled: filled
    }

    this.setState({
        ...this.state,
        ...newObj
    });
  }

  _onSubmit() {
    // @TODO: Validierung hinzufügen! 
    // Validierung der Daten 
    let withError = false;
    const items = this.state;
    let newState = {};

    Object.keys(items).forEach(function (key) {
        if(items[key].filled === false) {
            if(key !== "sended" && key !== "loading" && key !== "agb") {
                withError = true;
                newState[key] = {
                    ...items[key],
                    error: true
                }
            } else {
                newState[key] = items[key];
            }
        } else {
            newState[key] = items[key];
        }
    });

    if(withError) {
        this.setState({
            ...this.state,
            ...newState
        });
        console.log(this.state);
        return false;
    } else {
      this.setState({
        loading: true
      });
  
      client.createItem('bnb_mailer', {
        status: 'published',
        inserat_title: this.props.inserat.headline,
        mail_type: 1,
        inserat_type: 1,
        name: this.state.name.value,
        inserat_id: this.props.inserat.id,
        email_to: this.props.inserat.email,
        email_from: this.state.email.value,
        number: this.state.number.value,
        phone: this.state.phone.value,
        massage: this.state.about.value
      }).then(data => {
        window.location.href = "/homestay/anfrage-gesendet/";
  
      }).catch(err => {
        console.error(err);
        window.location.href = "/homestay/fehler/";
      })
    }
  }

  render() {
    let typeText = "";
    if(this.props.type === "bnb_angebote_kontakt")
      typeText = "Ich würde gerne übernachten"
    else 
      typeText = "Ich habe ein passendes Angebot"

    return (
      <div className={'contact_placeholder'}>
          {
            this.state.sended === false && 
            <div>
              <h2>{typeText}</h2>
              <div className={'full_width'}>
                <label>Vor- und Nachname *</label>
                {this.state.name.error && <p className="error_msg">Dies ist ein Pflichtfeld</p>}
                <input type={'text'} value={this.state.name.value} onChange={(e) => {this._onChangeValue('name', e.target.value)}} />
              </div>

              <div className={'full_width'}>
                <label>E-Mail-Adresse *</label>
                {this.state.email.error && <p className="error_msg">Dies ist ein Pflichtfeld</p>}
                <input type={'email'} value={this.state.email.value} onChange={(e) => {this._onChangeValue('email', e.target.value)}} />
              </div>

              <div className={'half_width'}>
                <div>
                  <label>Anzahl Gäste *</label>
                  {this.state.number.error && <p className="error_msg">Dies ist ein Pflichtfeld</p>}
                  <input type={'number'} min={'1'} max={'20'} value={this.state.number.value} onChange={(e) => {this._onChangeValue('number', e.target.value)}} />
                </div>
                <div>
                  <label>Telefonnummer *</label>
                  {this.state.phone.error && <p className="error_msg">Dies ist ein Pflichtfeld</p>}
                  <input type={'phone'} value={this.state.phone.value} onChange={(e) => {this._onChangeValue('phone', e.target.value)}} />
                </div>
              </div>
              <div className={'full_width'}>
                <label>Erzähle uns etwas über Dich und die Gäste *</label>
                {this.state.about.error && <p className="error_msg">Dies ist ein Pflichtfeld</p>}
                <textarea onChange={(e) => {this._onChangeValue('about', e.target.value)}} value={this.state.about.value}></textarea>
              </div>
              <div className={'checkbox_form'}>
                <input type="checkbox" id="agb_check" value={this.state.agb.value} />
                <label htmlFor="agb_check">Ich erkläre mich damit einverstanden, dass meine Daten dem Ersteller des Inserates zur Verfügung gestellt werden. Die Daten dienen ausschließlich zur Kontaktaufnahme in direktem Zusammenhang zu exakt diesem Inserat auf Worthaus.org. Alle weiteren Hinweise zum Datenschutz habe ich gelesen und zur Kenntnis genommen.</label>
              </div>
              <div>
                <p className={'requiredNote'}>* Pflichtfeld</p>
              </div>
              <div className={'full_width'}>
                {
                  this.state.loading === false && 
                  <a className={'btn_primary_form'} onClick={this._onSubmit}>Anfrage absenden</a>
                }
                {
                  this.state.loading === true && 
                  <a className={'btn_primary_form'}>Anfrage absenden</a>
                }
              </div>
            </div>
          }
          {
            this.state.sended === true && 
            <div className={'confirmed_msg'}>
              <h2>Erfolgreich</h2>
              <p>Wir haben Ihr Nachricht abgeschickt.<br />Sie sollten in den nächsten Tagen eine Antwort erhalten.</p>
            </div>
          }
      </div>
    )
  }
}